import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class MercenaryCampSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.MERCENARY_CAMP;
}

export default MercenaryCampSalvageableTileEntity;
